/**
 *
 * StudentworkMixin
 *
 */

//import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
//import _ from 'lodash';

export const VideoReportMixin = {
  name: 'VideoReportMixin',

  components: {
    'video-report': () => import('@/components/Survey/VideoReport.vue'),
  },

  methods: {
    //
    toPause() {
      //
    },

    showVideoReport() {
      this.toPause();
    },
  },
};

export default VideoReportMixin;
